import { ValidationResultItem } from '../typings/common';
import { GdRetargetingConditionRuleType } from '../typings/graphql-grid';
import { GroupId } from '../typings/groups';
import {
    RetargetingConditionData,
    RetargetingConditionGoal,
    RetargetingConditionRuleType
} from '../typings/retargeting';

export const OPEN_NEW_RETARGETING_CONDITION_EDITOR = 'OPEN_NEW_RETARGETING_CONDITION_EDITOR';
export type OPEN_NEW_RETARGETING_CONDITION_EDITOR = typeof OPEN_NEW_RETARGETING_CONDITION_EDITOR;

export interface OpenNewRetargetingConditionEditor {
    type: OPEN_NEW_RETARGETING_CONDITION_EDITOR;
    groupId: GroupId;
}

export function openNewRetargetingConditionEditor(groupId: GroupId): OpenNewRetargetingConditionEditor {
    return {
        type: OPEN_NEW_RETARGETING_CONDITION_EDITOR,
        groupId
    };
}

export const OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR = 'OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR';
export type OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR = typeof OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR;

export interface OpenNewAudienceRetargetingConditionEditor {
    type: OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR;
    groupId: GroupId;
}

export function openNewAudienceRetargetingConditionEditor(groupId: GroupId): OpenNewAudienceRetargetingConditionEditor {
    return {
        type: OPEN_NEW_AUDIENCE_RETARGETING_CONDITION_EDITOR,
        groupId
    };
}

export const OPEN_RETARGETING_CONDITION_EDITOR = 'OPEN_RETARGETING_CONDITION_EDITOR';
export type OPEN_RETARGETING_CONDITION_EDITOR = typeof OPEN_RETARGETING_CONDITION_EDITOR;

export interface OpenRetargetingConditionEditor {
    type: OPEN_RETARGETING_CONDITION_EDITOR;
    groupId: GroupId;
    conditionData: RetargetingConditionData;
}

export function openRetargetingConditionEditor(
    groupId: GroupId,
    conditionData: RetargetingConditionData
): OpenRetargetingConditionEditor {
    return {
        type: OPEN_RETARGETING_CONDITION_EDITOR,
        groupId,
        conditionData
    };
}

export const OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR = 'OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR';
export type OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR = typeof OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR;

export interface OpenAudienceRetargetingConditionEditor {
    type: OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR;
    groupId: GroupId;
    conditionData: RetargetingConditionData;
}

export function openAudienceRetargetingConditionEditor(
    groupId: GroupId,
    conditionData: RetargetingConditionData
): OpenAudienceRetargetingConditionEditor {
    return {
        type: OPEN_AUDIENCE_RETARGETING_CONDITION_EDITOR,
        groupId,
        conditionData
    };
}

export const CLOSE_RETARGETING_CONDITION_EDITOR = 'CLOSE_RETARGETING_CONDITION_EDITOR';
export type CLOSE_RETARGETING_CONDITION_EDITOR = typeof CLOSE_RETARGETING_CONDITION_EDITOR;

export interface CloseRetargetingConditionEditor {
    type: CLOSE_RETARGETING_CONDITION_EDITOR;
}

export function closeRetargetingConditionEditor(): CloseRetargetingConditionEditor {
    return {
        type: CLOSE_RETARGETING_CONDITION_EDITOR
    };
}

export const COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA = 'COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA';
export type COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA = typeof COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA;

export interface CompleteLoadingRetargetingConditionEditorData {
    type: COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA;
}

export function completeLoadingRetargetingConditionEditorData(): CompleteLoadingRetargetingConditionEditorData {
    return {
        type: COMPLETE_LOADING_RETARGETING_CONDITION_EDITOR_DATA
    };
}

export const SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR =
    'SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR';
export type SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR = typeof SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR;

export interface ShowLoadingRetargetingConditionEditorDataError {
    type: SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR;
    error: string;
}

export function showLoadingRetargetingConditionEditorDataError(
    error: string
): ShowLoadingRetargetingConditionEditorDataError {
    return {
        type: SHOW_LOADING_RETARGETING_CONDITION_EDITOR_DATA_ERROR,
        error
    };
}

export const UPDATE_RETARGETING_CONDITION_EDITOR_GOALS = 'UPDATE_RETARGETING_CONDITION_EDITOR_GOALS';
export type UPDATE_RETARGETING_CONDITION_EDITOR_GOALS = typeof UPDATE_RETARGETING_CONDITION_EDITOR_GOALS;

export interface UpdateRetargetingConditionEditorGoals {
    type: UPDATE_RETARGETING_CONDITION_EDITOR_GOALS;
    goals: Array<RetargetingConditionGoal>;
}

export function updateRetargetingConditionEditorGoals(
    goals: Array<RetargetingConditionGoal>
): UpdateRetargetingConditionEditorGoals {
    return {
        type: UPDATE_RETARGETING_CONDITION_EDITOR_GOALS,
        goals
    };
}

export const UPDATE_RETARGETING_CONDITION_NAME = 'UPDATE_RETARGETING_CONDITION_NAME';
export type UPDATE_RETARGETING_CONDITION_NAME = typeof UPDATE_RETARGETING_CONDITION_NAME;

export interface UpdateRetargetingConditionName {
    type: UPDATE_RETARGETING_CONDITION_NAME;
    name: string;
}

export function updateRetargetingConditionName(name: string): UpdateRetargetingConditionName {
    return {
        type: UPDATE_RETARGETING_CONDITION_NAME,
        name
    };
}

export const UPDATE_RETARGETING_CONDITION_DESCRIPTION = 'UPDATE_RETARGETING_CONDITION_DESCRIPTION';
export type UPDATE_RETARGETING_CONDITION_DESCRIPTION = typeof UPDATE_RETARGETING_CONDITION_DESCRIPTION;

export interface UpdateRetargetingConditionDescription {
    type: UPDATE_RETARGETING_CONDITION_DESCRIPTION;
    description: string;
}

export function updateRetargetingConditionDescription(description: string): UpdateRetargetingConditionDescription {
    return {
        type: UPDATE_RETARGETING_CONDITION_DESCRIPTION,
        description
    };
}

export const DELETE_RETARGETING_CONDITION_GROUP = 'DELETE_RETARGETING_CONDITION_GROUP';
export type DELETE_RETARGETING_CONDITION_GROUP = typeof DELETE_RETARGETING_CONDITION_GROUP;

export interface DeleteRetargetingConditionGroup {
    type: DELETE_RETARGETING_CONDITION_GROUP;
    groupIndex: number;
}

export function deleteRetargetingConditionGroup(groupIndex: number): DeleteRetargetingConditionGroup {
    return {
        type: DELETE_RETARGETING_CONDITION_GROUP,
        groupIndex
    };
}

export const ADD_RETARGETING_CONDITION_GROUP = 'ADD_RETARGETING_CONDITION_GROUP';
export type ADD_RETARGETING_CONDITION_GROUP = typeof ADD_RETARGETING_CONDITION_GROUP;

export interface AddRetargetingConditionGroup {
    type: ADD_RETARGETING_CONDITION_GROUP;
}

export function addRetargetingConditionGroup(): AddRetargetingConditionGroup {
    return {
        type: ADD_RETARGETING_CONDITION_GROUP
    };
}

export const UPDATE_RETARGETING_CONDITION_GROUP_TYPE = 'UPDATE_RETARGETING_CONDITION_GROUP_TYPE';
export type UPDATE_RETARGETING_CONDITION_GROUP_TYPE = typeof UPDATE_RETARGETING_CONDITION_GROUP_TYPE;

export interface UpdateRetargetingConditionGroupType {
    type: UPDATE_RETARGETING_CONDITION_GROUP_TYPE;
    groupIndex: number;
    value: GdRetargetingConditionRuleType;
}

export function updateRetargetingConditionGroupType(
    groupIndex: number,
    value: GdRetargetingConditionRuleType
): UpdateRetargetingConditionGroupType {
    return {
        type: UPDATE_RETARGETING_CONDITION_GROUP_TYPE,
        groupIndex,
        value
    };
}

export const UPDATE_RETARGETING_CONDITION_RULE_TYPE = 'UPDATE_RETARGETING_CONDITION_RULE_TYPE';
export type UPDATE_RETARGETING_CONDITION_RULE_TYPE = typeof UPDATE_RETARGETING_CONDITION_RULE_TYPE;

export interface UpdateRetargetingConditionRuleType {
    type: UPDATE_RETARGETING_CONDITION_RULE_TYPE;
    groupIndex: number;
    ruleIndex: number;
    value: RetargetingConditionRuleType;
}

export function updateRetargetingConditionRuleType(
    groupIndex: number,
    ruleIndex: number,
    value: RetargetingConditionRuleType
): UpdateRetargetingConditionRuleType {
    return {
        type: UPDATE_RETARGETING_CONDITION_RULE_TYPE,
        groupIndex,
        ruleIndex,
        value
    };
}

export const UPDATE_RETARGETING_CONDITION_RULE_PERIOD = 'UPDATE_RETARGETING_CONDITION_RULE_PERIOD';
export type UPDATE_RETARGETING_CONDITION_RULE_PERIOD = typeof UPDATE_RETARGETING_CONDITION_RULE_PERIOD;

export interface UpdateRetargetingConditionRulePeriod {
    type: UPDATE_RETARGETING_CONDITION_RULE_PERIOD;
    groupIndex: number;
    ruleIndex: number;
    value?: number;
}

export function updateRetargetingConditionRulePeriod(
    groupIndex: number,
    ruleIndex: number,
    value?: number
): UpdateRetargetingConditionRulePeriod {
    return {
        type: UPDATE_RETARGETING_CONDITION_RULE_PERIOD,
        groupIndex,
        ruleIndex,
        value
    };
}

export const UPDATE_RETARGETING_CONDITION_RULE_GOAL = 'UPDATE_RETARGETING_CONDITION_RULE_GOAL';
export type UPDATE_RETARGETING_CONDITION_RULE_GOAL = typeof UPDATE_RETARGETING_CONDITION_RULE_GOAL;

export interface UpdateRetargetingConditionRuleGoal {
    type: UPDATE_RETARGETING_CONDITION_RULE_GOAL;
    groupIndex: number;
    ruleIndex: number;
    value: string;
}

export function updateRetargetingConditionRuleGoal(
    groupIndex: number,
    ruleIndex: number,
    value: string
): UpdateRetargetingConditionRuleGoal {
    return {
        type: UPDATE_RETARGETING_CONDITION_RULE_GOAL,
        groupIndex,
        ruleIndex,
        value
    };
}

export const DELETE_RETARGETING_CONDITION_RULE = 'DELETE_RETARGETING_CONDITION_RULE';
export type DELETE_RETARGETING_CONDITION_RULE = typeof DELETE_RETARGETING_CONDITION_RULE;

export interface DeleteRetargetingConditionRule {
    type: DELETE_RETARGETING_CONDITION_RULE;
    groupIndex: number;
    ruleIndex: number;
}

export function deleteRetargetingConditionRule(groupIndex: number, ruleIndex: number): DeleteRetargetingConditionRule {
    return {
        type: DELETE_RETARGETING_CONDITION_RULE,
        groupIndex,
        ruleIndex
    };
}

export const ADD_RETARGETING_CONDITION_RULE = 'ADD_RETARGETING_CONDITION_RULE';
export type ADD_RETARGETING_CONDITION_RULE = typeof ADD_RETARGETING_CONDITION_RULE;

export interface AddRetargetingConditionRule {
    type: ADD_RETARGETING_CONDITION_RULE;
    groupIndex: number;
}

export function addRetargetingConditionRule(groupIndex: number): AddRetargetingConditionRule {
    return {
        type: ADD_RETARGETING_CONDITION_RULE,
        groupIndex
    };
}

export const UPDATE_VISITORS_FORECAST = 'UPDATE_VISITORS_FORECAST';
export type UPDATE_VISITORS_FORECAST = typeof UPDATE_VISITORS_FORECAST;

export interface UpdateVisitorsForecast {
    type: UPDATE_VISITORS_FORECAST;
    value: number;
}

export function updateVisitorsForecast(value: number): UpdateVisitorsForecast {
    return {
        type: UPDATE_VISITORS_FORECAST,
        value
    };
}

export const RESET_VISITORS_FORECAST = 'RESET_VISITORS_FORECAST';
export type RESET_VISITORS_FORECAST = typeof RESET_VISITORS_FORECAST;

export interface ResetVisitorsForecast {
    type: RESET_VISITORS_FORECAST;
}

export function resetVisitorsForecast(): ResetVisitorsForecast {
    return {
        type: RESET_VISITORS_FORECAST
    };
}

export const SHOW_VISITORS_FORECAST_ERROR = 'SHOW_VISITORS_FORECAST_ERROR';
export type SHOW_VISITORS_FORECAST_ERROR = typeof SHOW_VISITORS_FORECAST_ERROR;

export interface ShowVisitorsForecastError {
    type: SHOW_VISITORS_FORECAST_ERROR;
    error: string;
}

export function showVisitorsForecastError(error: string): ShowVisitorsForecastError {
    return {
        type: SHOW_VISITORS_FORECAST_ERROR,
        error
    };
}

export const SAVE_RETARGETING_CONDITION = 'SAVE_RETARGETING_CONDITION';
export type SAVE_RETARGETING_CONDITION = typeof SAVE_RETARGETING_CONDITION;

export interface SaveRetargetingCondition {
    type: SAVE_RETARGETING_CONDITION;
}

export function saveRetargetingCondition(): SaveRetargetingCondition {
    return {
        type: SAVE_RETARGETING_CONDITION
    };
}

export const SAVE_RETARGETING_CONDITION_AS_NEW = 'SAVE_RETARGETING_CONDITION_AS_NEW';
export type SAVE_RETARGETING_CONDITION_AS_NEW = typeof SAVE_RETARGETING_CONDITION_AS_NEW;

export interface SaveRetargetingConditionAsNew {
    type: SAVE_RETARGETING_CONDITION_AS_NEW;
}

export function saveRetargetingConditionAsNew(): SaveRetargetingConditionAsNew {
    return {
        type: SAVE_RETARGETING_CONDITION_AS_NEW
    };
}

export const SAVE_AUDIENCE_RETARGETING_CONDITION = 'SAVE_AUDIENCE_RETARGETING_CONDITION';
export type SAVE_AUDIENCE_RETARGETING_CONDITION = typeof SAVE_AUDIENCE_RETARGETING_CONDITION;

export interface SaveAudienceRetargetingConditionAsNew {
    type: SAVE_AUDIENCE_RETARGETING_CONDITION;
}

export function saveAudienceRetargetingCondition(): SaveAudienceRetargetingConditionAsNew {
    return {
        type: SAVE_AUDIENCE_RETARGETING_CONDITION
    };
}

export const SAVE_RETARGETING_CONDITION_SUCCESSED = 'SAVE_RETARGETING_CONDITION_SUCCESSED';
export type SAVE_RETARGETING_CONDITION_SUCCESSED = typeof SAVE_RETARGETING_CONDITION_SUCCESSED;

export interface SaveRetargetingConditionSuccessed {
    type: SAVE_RETARGETING_CONDITION_SUCCESSED;
    conditionData: RetargetingConditionData;
}

export function saveRetargetingConditionSuccessed(
    conditionData: RetargetingConditionData
): SaveRetargetingConditionSuccessed {
    return {
        type: SAVE_RETARGETING_CONDITION_SUCCESSED,
        conditionData
    };
}

export const SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED = 'SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED';
export type SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED = typeof SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED;

export interface SaveRetargetingConditionAsNewSuccessed {
    type: SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED;
    groupId: GroupId;
    conditionData: RetargetingConditionData;
}

export function saveRetargetingConditionAsNewSuccessed(
    groupId: GroupId,
    conditionData: RetargetingConditionData
): SaveRetargetingConditionAsNewSuccessed {
    return {
        type: SAVE_RETARGETING_CONDITION_AS_NEW_SUCCESSED,
        groupId,
        conditionData
    };
}

export const SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR =
    'SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR';
export type SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR = typeof SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR;

export interface ShowSavingRetargetingConditionEditorServerGlobalError {
    type: SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR;
    error: string;
}

export function showSavingRetargetingConditionEditorServerGlobalError(
    error: string
): ShowSavingRetargetingConditionEditorServerGlobalError {
    return {
        type: SHOW_SAVING_RETARGETING_CONDITION_EDITOR_SERVER_GLOBAL_ERROR,
        error
    };
}

export const SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS =
    'SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS';
export type SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS = typeof SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS;

export interface ShowRetargetingConditionEditorServerValidationErrors {
    type: SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS;
    errors: ValidationResultItem[];
}

export function showRetargetingConditionEditorServerValidationErrors(
    errors: ValidationResultItem[]
): ShowRetargetingConditionEditorServerValidationErrors {
    return {
        type: SHOW_RETARGETING_CONDITION_EDITOR_SERVER_VALIDATION_ERRORS,
        errors
    };
}

export const CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA = 'CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA';
export type CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA = typeof CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA;

export interface ChangeRetargetingConditionEditorIsSavingData {
    type: CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA;
    isSaving: boolean;
}

export const changeRetargetingConditionEditorIsSavingData = (
    isSaving: boolean
): ChangeRetargetingConditionEditorIsSavingData => {
    return {
        type: CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_DATA,
        isSaving
    };
};

export const CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA =
    'CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA';
export type CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA = typeof CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA;

export interface ChangeRetargetingConditionEditorIsSavingAsNewConditionData {
    type: CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA;
    isSavingAsNewCondition: boolean;
}

export const changeRetargetingConditionEditorIsSavingAsNewConditionData = (
    isSavingAsNewCondition: boolean
): ChangeRetargetingConditionEditorIsSavingAsNewConditionData => {
    return {
        type: CHANGE_RETARGETING_CONDITION_EDITOR_IS_SAVING_AS_NEW_CONDITION_DATA,
        isSavingAsNewCondition
    };
};

export type RetargetingConditionEditorAction =
    | OpenNewRetargetingConditionEditor
    | OpenRetargetingConditionEditor
    | OpenNewAudienceRetargetingConditionEditor
    | OpenAudienceRetargetingConditionEditor
    | CloseRetargetingConditionEditor
    | CompleteLoadingRetargetingConditionEditorData
    | UpdateRetargetingConditionEditorGoals
    | UpdateRetargetingConditionName
    | UpdateRetargetingConditionDescription
    | UpdateRetargetingConditionGroupType
    | UpdateRetargetingConditionRuleType
    | UpdateRetargetingConditionRuleGoal
    | UpdateRetargetingConditionRulePeriod
    | DeleteRetargetingConditionGroup
    | AddRetargetingConditionGroup
    | DeleteRetargetingConditionRule
    | AddRetargetingConditionRule
    | SaveRetargetingCondition
    | SaveRetargetingConditionAsNew
    | UpdateVisitorsForecast
    | ShowLoadingRetargetingConditionEditorDataError
    | SaveRetargetingConditionSuccessed
    | SaveRetargetingConditionAsNewSuccessed
    | ShowSavingRetargetingConditionEditorServerGlobalError
    | ShowVisitorsForecastError
    | ResetVisitorsForecast
    | ShowRetargetingConditionEditorServerValidationErrors
    | ChangeRetargetingConditionEditorIsSavingData
    | SaveAudienceRetargetingConditionAsNew
    | ChangeRetargetingConditionEditorIsSavingAsNewConditionData;
